import "./Home.scss"
import Logo from "../Atoms/Logos/Logo";
import styled from "styled-components";
import GreenBtnB from "../Atoms/Buttons/RedBtnB";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import NbrTan from "../Atoms/Rtans/NbrTan";
import {sendCPLog} from "../../Utils/Log/CPlog";

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    sendCPLog("nb_cardquiz_view", {"pagename": "landing"})
  }, [])
  return (
    <>
      <Wrapper className={"home"}>
        <NewChangeContainer>
          <Logo/>
          <NewChangeContentBox>
            <NbrTan/>
            <NewChangeContent>
              내가 <span>내일배움카드</span> 발급<br/>
              대상자인지 확인해보세요!
            </NewChangeContent>
          </NewChangeContentBox>
        </NewChangeContainer>

        <NbBTnContainer>
          <NbBtnTime>
            소요시간 20초
          </NbBtnTime>
          <GreenBtnB onClick={() => {
            navigate("/nb/selection")
          }}>
            확인해보기
          </GreenBtnB>
          <Caption>
            내일배움카드가 있으면 스파르타코딩클럽의 인기강의를 0원으로 수강할 수 있어요.
          </Caption>
        </NbBTnContainer>


      </Wrapper>
    </>
  )
}
export default Home

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 88px;
  margin-bottom: 60px;
`


const Caption = styled.div`
  width: 237px;
  height: 42px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;

  text-align: center;

  color: #81898F;

`

const NewChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 25px;
  width: 328px;
  height: 276.35px;
`;

const NbBTnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 32px;
  margin-top: 40px;

  width: 328px;
  height: 171px;
`

const NbBtnTime = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;

  text-align: center;


  color: #5F666B;
`


const NewChangeContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 247.61px;
  height: 203.35px;

`;

const NewChangeContent = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  text-align: center;
  color: #000000;

  span {
    color: #1F8648;
  }
`;
